module.exports = __webpack_public_path__ + "img/OT330778.27b0b9c.jpg";